// client/src/components/configuracoes/sinais/SinalRow.js
import React from 'react';
import { MoreVertical } from 'lucide-react';
import { useTenantI18n } from '../../../hooks/useAccounts';
import { formatCurrency } from '../../../utils/formatters';

const formatarData = (data) => {
    if (!data) return null;
    return new Date(data).toLocaleDateString('pt-BR');
};

const SinalRow = ({ sinal, onOpenActions }) => {
    // ✅ ACHADO: valorLabel era fixo em BRL, sem ler
    // configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();

    if (!sinal) return null;

    const alvoLabel = sinal.categoria
        ? `Categoria: ${sinal.categoria?.nome || '—'}`
        : sinal.servico
            ? `Serviço: ${sinal.servico?.nome || '—'}`
            : sinal.recurso
                ? `Recurso: ${sinal.recurso?.nome || '—'}`
                : '—';

    const valorLabel = sinal.tipoValor === 'percentual'
        ? `${sinal.valorPercentual}%`
        : formatCurrency(sinal.valorFixo || 0, currency, locale);

    const vigenciaInicio = formatarData(sinal.vigenciaInicio);
    const vigenciaFim = formatarData(sinal.vigenciaFim);
    const vigenciaLabel = !vigenciaInicio && !vigenciaFim
        ? 'Sempre'
        : `${vigenciaInicio || '...'} até ${vigenciaFim || '...'}`;

    return (
        <tr className="table-row-hover">
            <td className="td-name">
                <div className="font-medium">{sinal.nome}</div>
            </td>
            <td>
                <span className="badge badge-outline">{sinal.tipoAlvo === 'servico' ? 'Serviço' : 'Recurso'}</span>
            </td>
            <td>{alvoLabel}</td>
            <td>{valorLabel}</td>
            <td>{vigenciaLabel}</td>
            <td>
                {sinal.ativo ? <span className="badge badge-green">Ativa</span> : <span className="badge badge-red">Inativa</span>}
            </td>
            <td className="text-right">
                <button
                    onClick={() => onOpenActions(sinal)}
                    title="Ações"
                    className="action-button-icon text-gray-600 hover:text-gray-900"
                >
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

export default SinalRow;
